import { compose, isEmpty, isNil } from 'lodash/fp';
import { TextKey } from '@mews-commander/enums';
import { createAsyncActionTypes, createAction } from '@mews/framework';
import { ApplicationState, WithOwnerId } from '@mews-commander/types';
import { Address } from '@mews-commander/data-access';
import { mapId, localizeText, sortByDescending } from '@mews-commander/utils';
import parentSelector from '../selector';
import prefix from '../prefix';
import { createEntitiesReducer, createBaseEntitySelectors } from './utils';

export const NAME = 'addresses';

export const ADDRESSES_LOADED = prefix('ADDRESSES_LOADED');

export const ADDRESS_ADD = prefix('ADDRESS_ADD');
export const [ADDRESS_ADD_STARTED, ADDRESS_ADD_SUCCEEDED, ADDRESS_ADD_FAILED] = createAsyncActionTypes(ADDRESS_ADD);
export const ADDRESS_UPDATE = prefix('ADDRESS_UPDATE');
export const [ADDRESS_UPDATE_STARTED, ADDRESS_UPDATE_SUCCEEDED, ADDRESS_UPDATE_FAILED] =
    createAsyncActionTypes(ADDRESS_UPDATE);
export const ADDRESS_DELETE = prefix('ADDRESS_DELETE');
export const [ADDRESS_DELETE_STARTED, ADDRESS_DELETE_SUCCEEDED, ADDRESS_DELETE_FAILED] =
    createAsyncActionTypes(ADDRESS_DELETE);

export const setAddresses = (addresses: Array<Address>, ownerId: string) =>
    createAction(ADDRESSES_LOADED, { entities: addresses, ownerId });

export default createEntitiesReducer({
    FETCH_SUCCESS: ADDRESSES_LOADED,
    ADD_SUCCESS: ADDRESS_ADD_SUCCEEDED,
    UPDATE_SUCCESS: ADDRESS_UPDATE_SUCCEEDED,
    DELETE_SUCCESS: ADDRESS_DELETE_SUCCEEDED,
});

export const [getAddresses, getAddressesByIds, getAddressesByOwnerId, getAddress] = createBaseEntitySelectors<
    ApplicationState,
    Address & WithOwnerId,
    typeof NAME
>(parentSelector, NAME);

export const getAddressTitle = (address: Address) => {
    if (isNil(address) || isEmpty(address.addressLine1)) {
        return localizeText(TextKey.Address);
    }

    return address.addressLine1;
};

const sortByCreatedUtcDescending = sortByDescending('createdUtc');

export const getSortedAddressIdsByOwnerId = compose(mapId, sortByCreatedUtcDescending, getAddressesByOwnerId);
